import React, { Component } from "react";
import { Button, Accordion } from "react-bootstrap";
import "../../Components/Events/EventCard/index.css";
import defaultImage from "../../Assets/img/default-cover-image.svg";
import Skeleton from "react-loading-skeleton";

class EventCard2 extends Component {
  render() {
    return (
      <div className="shadow-sm rounded th-event-card">
        {/* {this.props.loading ? (
          <Skeleton className="th-event-card-img" />
        ) : (
          <div
            className="th-event-card-img"
            style={{
              backgroundImage: `url(${
                this.props.img ? this.props.img : defaultImage
              })`,
            }}
          ></div>
        )} */}

        <div className="px-2 pb-2 pt-1">
          <Accordion defaultActiveKey={null}>
            <div>
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="1"
                style={{
                  padding: 0,
                  textDecoration: "none",
                  boxShadow: "none",
                  width: "100%",
                }}
              >
                {this.props.loading ? (
                  <Skeleton height={25} />
                ) : (
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <div className="th-14 th-black text-left text-capitalize">
                        {this.props.title}
                      </div>
                      <div className="th-12 th-grey text-left">
                        {this.props.date}
                      </div>
                    </div>
                    <i
                      className="fa fa-angle-down th-primary"
                      aria-hidden="true"
                    ></i>
                  </div>
                )}
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="1">
                <div className="mt-2">
                  <div className="th-12 th-grey text-left text-capitalize">
                    {this.props.description}
                  </div>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
    );
  }
}
export default EventCard2;
